import { useAppOverlayStore } from '@/stores/appOverlay';

export function useAppLoading() {
    return useAppOverlayStore();
}
